import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { motion } from "framer-motion";

const faqs = [
  {
    question: "Welche Leistungen bietet ihr an?",
    answer: "Wir bieten professionellen Umzugsservice, Möbelmontage, Bodenbelag (Laminat, Vinyl), Lichtinstallation und Pflasterarbeiten an. Alles aus einer Hand für einen reibungslosen Ablauf."
  },
  {
    question: "Sind meine Möbel während des Umzugs versichert?",
    answer: "Absolut. Sicherheit steht bei uns an erster Stelle. Jeder Umzug ist über unseren Kravag-Logistik Versicherungsschutz umfassend abgesichert, sodass Sie sich keine Sorgen um eventuelle Transportschäden machen müssen."
  },
  {
    question: "Baut ihr auch Küchen und große Schränke ab und wieder auf?",
    answer: "Ja, unsere erfahrenen Handwerker übernehmen die komplette Demontage und fachgerechte Möbelmontage in Ihrem neuen Zuhause. Dazu gehören auch komplexe Schrankwände, Betten und Küchenzeilen."
  },
  {
    question: "Gibt es eine Gebühr für eine Beratung oder einen Kostenvoranschlag?",
    answer: "Nein, unser Kostenvoranschlag und die Erstberatung sind für Sie völlig kostenlos und unverbindlich. Wir erstellen Ihnen ein transparentes Angebot ohne versteckte Kosten."
  },
  {
    question: "Bietet ihr auch kurzfristige Umzugstermine an?",
    answer: "Ja, je nach Kapazität können wir auch kurzfristige Umzüge in Augsburg und Umgebung realisieren. Kontaktieren Sie uns am besten telefonisch, damit wir Ihren Wunschtermin schnellstmöglich prüfen und einplanen können."
  },
  {
    question: "Führt ihr Umzüge nur in Augsburg durch oder auch überregional?",
    answer: "Unser Fokus liegt auf Augsburg, München, Ulm, Ingolstadt und der gesamten Region Bayern. Für überregionale Umzüge oder Fernumzüge sprechen Sie uns einfach an – wir finden die passende Lösung für Sie."
  },
  {
    question: "Was unterscheidet euch von anderen Anbietern in der Gegend?",
    answer: "Mit über 10 Jahren Erfahrung bieten wir nicht nur Transport, sondern einen umfassenden Service inklusive Möbelmontage, Elektro- und Lichtinstallation sowie Bodenbelag. Unser Kravag-Logistik Versicherungsschutz gibt Ihnen zusätzliche Sicherheit."
  },
  {
    question: "Könnt ihr Referenzen von früheren Kunden vorweisen?",
    answer: "Ja, wir haben zahlreiche positive Bewertungen auf Google und können auf Wunsch weitere Referenzen unserer zufriedenen Kunden bereitstellen. Kundenzufriedenheit ist unser höchstes Gut."
  }
];

const FAQ = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };

  return (
    <section className="py-20 bg-white overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
        />
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="font-semibold text-primary uppercase tracking-wider text-sm">Häufig gestellte Fragen</span>
            <h2 className="font-heading text-3xl md:text-5xl mt-2 mb-8">Alles was du wissen musst</h2>
            
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((faq, index) => (
                <AccordionItem key={index} value={`item-${index}`} className="border-b border-neutral-200">
                  <AccordionTrigger className="font-heading text-left text-lg hover:text-primary transition-colors">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-neutral-600 font-medium text-base leading-relaxed">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>
          
          <motion.div 
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="relative hidden lg:block group"
          >
            <div className="absolute inset-0 bg-primary translate-x-4 translate-y-4 z-0 transition-transform duration-500 group-hover:translate-x-6 group-hover:translate-y-6"></div>
            <img 
              src="https://images.leadconnectorhq.com/image/f_webp/q_80/r_800/u_https://assets.cdn.filesafe.space/Zrqvy6cNzSbnzDV55cv1/media/6936df93510108064e5c6aff.jpg" 
              alt="FAQ Image" 
              width="800"
              height="1200"
              loading="lazy"
              decoding="async"
              className="relative z-10 w-full h-[600px] object-cover object-top transition-transform duration-500 group-hover:-translate-y-2 group-hover:-translate-x-2"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;